<template>
  <div class="product-form-container">
    <div v-if="loading" class="loading-overlay">
      <div class="spinner"></div>
    </div>

    <div v-if="error" class="error-message">
      {{ error }}
    </div>

    <div class="grid grid-cols-6 md:grid-cols-6 gap-1 product-form">
      <div class="col-span-1 md:col-span-1 form-group relative">
        <label for="pic">تصویر </label>
        <div>
          <img
              v-if="formData.image"
              id="pic"
              :src="img_source(formData.image)"
              class="w-112 h-12 rounded-lg object-cover border border-orange-200 shadow-sm"
          >
          <img
              v-else
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6oUHndoUSS1Lk01b_KKy5GK8YyegmvZ4Hrg&s"
              class="w-12 h-12 rounded-md object-cover border border-orange-200 shadow-sm"
          />

        </div>
      </div>
      <div class=" col-span-3 md:col-span-3 form-group">
        <label for="name">نام محصول</label>
        <textarea
            id="name"
            v-model="formData.name"
            type="text"
            class="form-input text-right"
        />
      </div>
      <div class=" col-span-2 md:col-span-2 form-group">
        <label for="sixteen_digit_code">کد 16 رقمی</label>
        <textarea
            type="text"
            id="sixteen_digit_code"
            v-model="formData.sixteen_digit_code"
            class="form-input text-right"
        />
      </div>
      <div class="col-span-3 md:col-span-3 bg-white bg-opacity-20 backdrop-filter backdrop-blur-lg pa-1 rounded-sm" v-if="formData.type != 'variable'">
        <div class="grid grid-cols-2 md:grid-cols-2 gap-1">
          <div class="col-span-2 md:col-span-3 form-group">
            <h6 class="text-[9px] font-medium white--text border-b pb-1 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-2 text-yellow-500" fill="none" viewBox="0 0 24 24"
                   stroke="pink">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
              </svg>
              موجودی
            </h6>
          </div>
          <div class="col-span-1 md:col-span-1 form-group">
            <label for="inventory">موجودی پردازش</label>
            <input
                id="inventory"
                v-model="formData.inventory"
                class="form-input text-center"
            />
          </div>

          <div class="col-span-1 md:col-span-1 form-group">
            <label for="minimum_inventory">حداقل موجودی</label>
            <input
                id="minimum_inventory"
                v-model="formData.minimum_inventory"
                class="form-input text-center"
            />
          </div>
          <div class="col-span-1 md:col-span-1 form-group">
            <div class="col-span-1 md:col-span-1 form-group">
              <label >انقضا</label>
              <date-field
                  v-model="formData.expired_date"
              />
            </div>
          </div>

        </div>
      </div>

      <div v-if="formData.type != 'variable'" :class='formData.type !="variable"?
       "col-span-3 md:col-span-3 bg-white bg-opacity-20 backdrop-filter backdrop-blur-lg pa-1 rounded-sm":"col-span-6 md:col-span-6 bg-white bg-opacity-20 backdrop-filter backdrop-blur-lg pa-1 rounded-sm" '>
        <div class="grid grid-cols-2 md:grid-cols-2 gap-1">
          <div class="col-span-2 md:col-span-2 form-group">
            <h6 class="text-[9px] font-medium white--text border-b pb-1 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-2 text-yellow-500" fill="none" viewBox="0 0 24 24"
                   stroke="pink">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 21h18v-2H3v2zM3 7v10h18V7H3zM12 7v10m-5-10v10m10-10v10"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                      d="M6 10h2m2 0h2m2 0h2m2 0h2M6 14h2m2 0h2m2 0h2m2 0h2"/>
              </svg>
              کد قفسه
            </h6>
          </div>
          <div class="col-span-1 md:col-span-1 form-group">
            <label for="shelf_number">ستون قفسه</label>
            <input
                id="shelf_number"
                v-model="formData.shelf_number"
                class="form-input text-center"
            />
          </div>

          <div class="col-span-1 md:col-span-1 form-group">
            <label for="aisle">ردیف قفسه </label>
            <input
                id="aisle"
                v-model="formData.aisle"
                class="form-input text-center"
            />
          </div>

        </div>
      </div>

      <div class="col-span-6 md:col-span-6 bg-white bg-opacity-20 backdrop-filter backdrop-blur-lg pa-1 rounded-sm" v-if="formData.type != 'variable'">
        <div class="grid grid-cols-4 md:grid-cols-4 gap-1">
          <div class="col-span-4 md:col-span-4 form-group">
            <h6 class="text-[9px] font-medium white--text border-b pb-1 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-2 text-blue-500" fill="none" viewBox="0 0 24 24"
                   stroke="pink">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4m4-6l4-4m0 0l-4-4m4 4H8"/>
              </svg>
              اطلاعات پستی
            </h6>
          </div>
          <div class="col-span-1 md:col-span-1 form-group">
            <label for="postal_weight">وزن پستی (گرم)</label>
            <input
                id="postal_weight"
                v-model="formData.postal_weight"
                class="form-input text-center"
            />
          </div>
          <div class="col-span-1 md:col-span-1 form-group">
            <label for="length">طول (سانتی‌متر)</label>
            <input
                id="length"
                v-model="formData.length"
                class="form-input text-center"
            />
          </div>
          <div class=" col-span-1 md:col-span-1 form-group">
            <label for="width">عرض (سانتی‌متر)</label>
            <input
                id="width"
                v-model="formData.width"
                class="form-input text-center"
            />
          </div>
          <div class="col-span-1 md:col-span-1 form-group">
            <label for="height">ارتفاع (سانتی‌متر)</label>
            <input
                id="height"
                v-model="formData.height"
                class="form-input text-center"
                dir="ltr"
            />
          </div>
        </div>
      </div>

      <div v-if="formData.variations.length > 0" class="col-span-6 md:col-span-6 bg-white bg-opacity-20 backdrop-filter backdrop-blur-lg pa-1 rounded-sm">
        <div class="grid grid-cols-6 md:grid-cols-6 gap-1">
          <div class="col-span-6 md:col-span-6 form-group">
            <h6 class="text-[9px] font-medium white--text border-b pb-1 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-2 text-blue-500" fill="none" viewBox="0 0 24 24"
                   stroke="pink">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4m4-6l4-4m0 0l-4-4m4 4H8"/>
              </svg>
              تنوع محصول
            </h6>
          </div>
        </div>
      </div>
      <div
          v-if="formData.variations.length > 0"
          v-for="variation in formData.variations"
          :key="variation.id"
          class=" ml-2  pt-1 pl-1 pr-1 col-span-8 md:col-span-8 gap-1 flex items-start bg-white bg-opacity-20 backdrop-blur-lg  rounded-sm"
      >
        <div class="col-span-1 md:col-span-1 form-group">
          <img
              v-if="variation.picture"
              :src="img_source('/media/uploads/' + variation.picture)"
              class="w-14 h-14 rounded-md object-cover border border-orange-200 shadow-sm"
          />
          <img
              v-else
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6oUHndoUSS1Lk01b_KKy5GK8YyegmvZ4Hrg&s"
              class="w-14 h-14 rounded-md object-cover border border-orange-200 shadow-sm"
          />
        </div>

        <div class="flex flex-col col-span-2 md:col-span-2">
          <textarea
              v-model="variation.name"
              placeholder="نام محصول"
              class="form-input text-right text-xs"
          ></textarea>
        </div>
        <div class="flex flex-col col-span-2 md:col-span-2">
          <textarea
              v-model="variation.sixteen_digit_code"
              placeholder="کد 16 رقمی"
              class="form-input text-right text-xs"
          ></textarea>
        </div>

        <div class="flex flex-col col-span-1 md:col-span-1">
          <div class="form-group">
            <label for="inventory">موجودی پردازش</label>
            <input
                v-model="variation.inventory"
                class="form-input text-center text-sm leading-none"
            />
          </div>
        </div>
        <div class="flex flex-col col-span-1 md:col-span-1">
          <div class="form-group">
            <label for="inventory">حداقل موجودی</label>
            <input
                v-model="variation.minimum_inventory"
                class="form-input text-center text-sm leading-none"
            />
          </div>
        </div>
        <div class="col-span-1 md:col-span-1 form-group">
          <label for="shelf">ستون قفسه</label>
          <input
              id="shelf"
              v-model="variation.shelf_number"
              class="form-input text-center"
          />
        </div>

        <div class="col-span-1 md:col-span-1 form-group">
          <label >ردیف قفسه </label>
          <input
              v-model="variation.aisle"
              class="form-input text-center"
          />
        </div>
        <div class="col-span-1 md:col-span-1 form-group">
          <label >وزن پستی (گرم)</label>
          <input
              type="number"
              step="any"
              v-model="variation.postal_weight"
              class="form-input text-center"
          />
        </div>
        <div class="col-span-1 md:col-span-1 form-group">
          <label >طول (سانتی‌متر)</label>
          <input
              type="number"
              step="any"
              v-model="variation.length"
              class="form-input text-center"
          />
        </div>
        <div class=" col-span-1 md:col-span-1 form-group">
          <label >عرض (سانتی‌متر)</label>
          <input
              type="number"
              step="any"
              v-model="variation.width"
              class="form-input text-center"
          />
        </div>
        <div class="col-span-1 md:col-span-1 form-group">
          <label >ارتفاع (سانتی‌متر)</label>
          <input
              type="number"
              step="any"
              v-model="variation.height"
              class="form-input text-center"
              dir="ltr"
          />
        </div>
        <div class="col-span-1 md:col-span-1 form-group">
          <label >انقضا</label>
          <date-field
              v-model="variation.expired_date"
          />
        </div>

      </div>
    </div>


    <div class="">
      <div class="form-actions">
        <button type="submit"
                class="submit-btn text-center  rounded-xl text-md font-bold shadow-md transition-all duration-300 transform hover:scale-105  bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 hover:bg-[#F17359] "
                @click="submitStoreForm">
          ثبت
        </button>
        <transition name="slide-fade">
          <div v-if="showNotification"
               class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-[90%] max-w-xs text-gray-100 bg-gray-900 rounded-lg shadow-lg border border-gray-700">

            <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-400 bg-gray-800">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"/>
              </svg>
            </div>

            <div class="mr-3 text-sm font-normal pr-2">انبارگردانی با موفقیت ثبت شد</div>

            <button @click="showNotification = false"
                    class="mr-auto text-gray-400 hover:text-white rounded-lg p-1.5 hover:bg-gray-800">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clip-rule="evenodd"/>
              </svg>
            </button>
          </div>
        </transition>

      </div>
    </div>


  </div>
</template>

<script>
import DateField from "@/components/mcomponents/cleave/DateField";
export default {
  name: 'PackingStoreHandle',
  components: {DateField},
  props: {
    productId: {},
  },
  data() {
    return {
      loading: false,
      showNotification: false,
      error: null,
      submitting: false,
      formData: {
        sixteen_digit_code: '',
        name: '',
        postal_weight: null,
        length: null,
        width: null,
        height: null,
        type: null,
        inventory: null,
        expired_date: null,
        minimum_inventory: null,
        aisle: '',
        shelf_number: '',
        variations: [],
      }
    }
  },
  watch: {
    productId() {
      if (this.id) {
        this.fetchProductData()
      } else {
        this.formData = {
          sixteen_digit_code: '',
          name: '',
          image: null,
          postal_weight: null,
          length: null,
          width: null,
          height: null,
          inventory: null,
          type: null,
          expired_date: null,
          minimum_inventory: null,
          aisle: '',
          shelf_number: '',
          variations: [],
        }

      }
    },
  },

  mounted() {
    this.fetchProductData()
  },
  methods: {
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },

    fetchProductData() {
      this.loading = true
      this.request({
        url: this.endpoint(`store_handle/productHandleChange/${this.productId}`),
        method: 'get',
        success: (response) => {
          this.request({
            url: this.endpoint(`store_handle/packingInventoryHandle/${this.productId}`),
            method: 'get',
            success: (data) => {
              this.formData = {
                sixteen_digit_code: response.sixteen_digit_code,
                name: response.name,
                image: response.image,
                postal_weight: response.postal_weight,
                length: response.length,
                width: response.width,
                height: response.height,
                aisle: response.aisle,
                type: response.type,
                expired_date: response.expired_date,
                shelf_number: response.shelf_number,
                variations: response.variations,
                inventory: data.inventory,
                minimum_inventory: data.minimum_inventory,
              }
              this.loading = false
            },
          })

        },
      })
    },

    submitStoreForm() {
      this.request({
        url: this.endpoint(`store_handle/productHandleChange/${this.productId}`),
        method: 'post',
        data: {
          sixteen_digit_code: this.formData.sixteen_digit_code,
          name: this.formData.name,
          postal_weight: this.formData.postal_weight,
          length: this.formData.length,
          width: this.formData.width,
          height: this.formData.height,
          expired_date: this.formData.expired_date,
          aisle: this.formData.aisle,
          shelf_number: this.formData.shelf_number
        },
        success: (data) => {
          this.request({
            url: this.endpoint(`store_handle/packingInventoryHandle/${this.productId}`),
            method: 'post',
            data: {
              inventory: this.formData.inventory,
              minimum_inventory: this.formData.minimum_inventory,
              variations: this.formData.variations,
            },
            success: (data) => {
              this.showNotificationMessage()
              setTimeout(() => {
                this.$emit('close')
              }, 1000);

            },
          })
        },
      })

    },
    handleCancel() {
      this.$emit('cancel')
      window.history.back()
    }
  }
}
</script>

<style scoped>
.product-form-container {
  position: relative;
  margin: auto;
  font-family: 'IRANSans', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  direction: rtl;
  text-align: right;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  direction: ltr;
  border-radius: 16px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #4a6cf7;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.error-message {
  color: #fff;
  background: rgba(255, 71, 87, 0.8);
  padding: 12px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  text-align: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.product-form {
  background: rgba(255, 255, 255, 0.2);
  padding: 25px;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.form-title {
  margin-top: 0;
  margin-bottom: 20px;
  color: #2d3748;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  position: relative;
  padding-bottom: 10px;
}

.form-title:after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 50%;
  transform: translateX(50%);
  width: 60px;
  height: 2px;
  background: linear-gradient(to right, rgba(74, 108, 247, 0.7), rgba(106, 17, 203, 0.7));
  border-radius: 2px;
}

.form-group {
  margin-bottom: 5px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.form-row .form-group {
  flex: 1;
  min-width: 200px;
}

label {
  display: block;
  margin-bottom: 4px;
  font-weight: 400;
  color: #fff;
  font-size: 7px;
}

.form-input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 8px;
  font-size: 8px;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.7);
  color: #2d3748;
}

.form-input:focus {
  border-color: rgba(74, 108, 247, 0.7);
  outline: none;
  box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.2);
  background-color: rgba(255, 255, 255, 0.9);
}

.form-input[dir="ltr"] {
  direction: ltr;
  text-align: left;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.submit-btn, .cancel-btn {
  padding: 10px 22px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  min-width: 100px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
}

.submit-btn {
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(74, 108, 247, 0.4);
}

.submit-btn:disabled {
  background: rgba(203, 213, 224, 0.7);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.cancel-btn {
  background-color: rgba(226, 232, 240, 0.5);
  color: #4a5568;
  border: 1px solid rgba(226, 232, 240, 0.5);
}

.cancel-btn:hover {
  background-color: rgba(247, 1, 252, 0.2);
  border-color: rgba(203, 213, 224, 0.7);
}

@media (max-width: 768px) {
  .product-form {
    padding: 1px;
    border-radius: 8px;
  }

  .form-row {
    flex-direction: column;
    gap: 5px;
  }

  .form-row .form-group {
    min-width: 100%;
  }

  .form-actions {
    flex-direction: column;
    gap: 10px;
  }

  .submit-btn, .cancel-btn {
    width: 100%;
    padding: 12px;
  }

  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5px;
  }

  .form-title {
    font-size: 13px;
    margin-bottom: 15px;
  }
}
</style>
